"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var FlashMessagesService = (function () {
    function FlashMessagesService() {
    }
    return FlashMessagesService;
}());
FlashMessagesService.decorators = [
    { type: core_1.Injectable },
];
/** @nocollapse */
FlashMessagesService.ctorParameters = function () { return []; };
exports.FlashMessagesService = FlashMessagesService;
//# sourceMappingURL=flash-messages.service.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angular2-flash-messages/module/flash-messages.service.js
// module id = ../../../../angular2-flash-messages/module/flash-messages.service.js
// module chunks = 7